import React from 'react';
import { loginPageStyles } from '../../../../styles';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useLiveFeed } from '../../../../hooks';
import { Toast as CustomToast, QrScanner } from '../../../../Components';
import { toast } from 'material-react-toastify';
import { useSelector } from 'react-redux';

const CableTieQrScreen = ({ setStep }) => {
  const classes = loginPageStyles();
  const [hasRecieved, setHasRecieved, enroutedPracticeId] = useLiveFeed();
  const enroutedPractices = useSelector(
    (state) => state.practicesReducer.enroutedPractices
  );

  const validateQRCode = (scanResult) => {
    if (scanResult) {
      setStep((prev) => prev + 1);
    }
  };

  // This function handles new Order Alert
  const handleNewOrderAlert = () => {
    toast(
      <CustomToast
        severity="info"
        message={
          enroutedPracticeId === enroutedPractices[0]?.id
            ? 'New Orders Assigned. Tap to view'
            : 'New Orders Assigned'
        }
        handleClick={() =>
          enroutedPracticeId === enroutedPractices[0]?.id &&
          setStep((prev) => prev - 1)
        }
      />,
      {
        closeButton: false,
        autoClose:
          enroutedPracticeId === enroutedPractices[0]?.id ? false : true,
      }
    );
    setHasRecieved(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        className={classes.heading10}
        sx={{
          textAlign: 'center',
          fontWeight: '700',
          fontSize: '21px',
          lineHeight: '27px',
          color: '#054E8B',
          fontFamily: 'Mukta',
          mt: '8px',
          mb: '11.5px',
        }}
      >
        Scan Cable Tie Bag QR Code
        {hasRecieved && handleNewOrderAlert()}
      </Box>
      <QrScanner validateQRCode={validateQRCode} />
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            fontFamily: 'Mulish',
            fontSize: '15px',
            textAlign: 'center',
            maxWidth: '330px',
            width: '100%',
            marginTop: '10px',
            marginBottom: '44px',
            display: 'flex',
            justifyContent: 'center',
            color: '#2A3752',
            lineHeight: '18.83px',
          }}
        >
          Align the QR code within the highlighted area of the overlay.
        </Box>
      </Box>
    </Box>
  );
};
CableTieQrScreen.propTypes = {
  setStep: PropTypes.func.isRequired,
};
export default CableTieQrScreen;
